export default class SpatialReference {
    public wkid = '';
    public latestWkid = '';

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.wkid) {
            this.wkid = model.wkid;
        }
        if (model.latestWkid) {
            this.latestWkid = model.latestWkid;
        }
    }
}
